import { Box, IconButton } from '@chakra-ui/react'

import StarRating from '@/components/assets/StarRating'
import { Tooltip } from '@/components/ui/tooltip'
import useColorModeValue from '@/hooks/useColorModeValue'

interface IStarProps {
    id: string
    filled: boolean
    onMouseEnter: () => void
    onMouseLeave: () => void
    onClick: () => void
}

const Star: React.FC<IStarProps> = ({ id, filled, onMouseEnter, onMouseLeave, onClick }) => {
    const borderColor = useColorModeValue('var(--chakra-colors-gray-250)', 'var(--chakra-colors-gray-500)')

    return (
        <Box mt="12px" mb="12px">
            <Tooltip content={`Rate ${id} stars`} aria-label={`Rate ${id} stars`} positioning={{ placement: 'top' }} variant="gsk">
                <IconButton
                    aria-label={`Rate ${id} stars`}
                    variant="solid"
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                    onClick={onClick}
                    backgroundColor={filled ? 'black' : 'white'}
                    fontSize="24px"
                    transition="background-color 0.3s ease, color 0.3s ease"
                    borderRadius="8px"
                    border={`1px solid ${borderColor}`}
                >
                    <StarRating color={filled ? 'white' : 'black'} />
                </IconButton>
            </Tooltip>
        </Box>
    )
}

export default Star
